import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// import reportWebVitals from './reportWebVitals'

import "./style.css"
import "./styles/w3.css"

import "material-icons/iconfont/material-icons.css"
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-photo-view/dist/react-photo-view.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
